import React from "react";
import { GridCell } from "@progress/kendo-react-grid";
import { Link } from "react-router-dom";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { LocalStorageService, ContractService } from "../../../services";
import SvgIcon from "@material-ui/core/SvgIcon";
import moment from "moment";

function Container({
  children,
  id,
  view,
  setIsShowAutorizationModal,
  userTypeId,
  killMe,
  signatureTypeId,
  urlToSend
}) {
  if (userTypeId) {
    return (
      <Link
        to={{
          pathname: urlToSend,
        }}
      >
        {children}
      </Link>
    );
  } else if (killMe) {
    return (
      <a onClick={killMe} className="primaryBtn">
        {children}
      </a>
    );
  } else {
    return (
      <a
        onClick={() => setIsShowAutorizationModal(true)}
        className="primaryBtn"
      >
        {children}
      </a>
    );
  }
}

export default function cellDetailSignatureRequest({
  edit,
  selectedFilter,
  seeDetail,
  tracking,
  tooltipDetail,
  tooltipDelete,
  toggleDialogDeleteRequest,
  view,
  visibilityIcon,
  setIsShowAutorizationModal,
  isHideTrash,
  killMe,
}) {
  return class extends GridCell {
    localStorageService = new LocalStorageService();
    contractService = new ContractService(process.env.REACT_APP_MIFIRMA_API)

    state = {
      miFirmaId: 0,
    };
    componentDidMount = async () => {
      let user = await this.localStorageService.getLocalStorageItem("user");
      let contractUser = this.localStorageService.getLocalStorageItem('contractUserExist')
      let contactExist = contractUser && contractUser.data?.userHadContracts && contractUser.data?.userHadContracts !== '' ? contractUser.data?.userHadContracts : true
      this.props.dataItem.contactExistFlag = contactExist
      this.setState({
        miFirmaId: user.userMetaData.userMifirma.id,
        clientId: user.userMetaData.userMifirma.clientId,
      });
    };
    render() {
      const { signatureTypeId } = this?.props?.dataItem;
      const isAReportDetail = this.props.dataItem?.isARequestFromRequestReport;
      let hideTrash =
        Number(this.props.dataItem.user.userTypeId) === 3 ? true : false;
      hideTrash =
        this.state.miFirmaId != this.props.dataItem.userId ? true : false;
      hideTrash = isAReportDetail ? true : false;

      if (selectedFilter) {
        hideTrash = true
        if (this.props.dataItem.signRequestStatusId < 2 && this.props.dataItem.signRequestStatusId > 2) {
          hideTrash = true
        } else if (this.props.dataItem.signRequestStatusId === 2 && selectedFilter === 2) {
          hideTrash = false
        } else if (this.props.dataItem.signRequestStatusId === 2 && this.props.dataItem.userId === this.props.dataItem.user.id && selectedFilter == 1) {
          hideTrash = false
        } else if (this.props.dataItem.signRequestStatusId === 2 && this.props.dataItem.userId != this.props.dataItem.user.id && selectedFilter == 1) {
          hideTrash = true
        }
      }

      //Check the creation date of the signature request, and if it is after 2025-01-27 send it to the route detail-signature-sign/id  otherwise, send it to the route detail/id/request-signature-detail
      const createdDateBD = this.props.dataItem.createdDateBD;
      const signRequestDate = moment(createdDateBD, "DD/MM/YYYY");
      const deployDate = moment(process.env.REACT_APP_DEPLOY_SIGN_DATE, "YYYY-MM-DD");

      //Compare if the creation date of the request is greater than or equal to the deploy date.
      //const isSignatureRequestAfterDeploy = moment(signRequestDate).isSameOrAfter(deployDate);

      //Compare  if the creation date of the request is greater than the deploy date.
      const isSignatureRequestAfterDeploy = moment(signRequestDate).isAfter(deployDate);

      const urlToSend = isSignatureRequestAfterDeploy ? `/detail-signature-sign/${this.props.dataItem.id}` : `${signatureTypeId === 0 ? "request" : "detail"}/${this.props.dataItem.id}/${view === "/" ? "index" : `${view}`}`;

      return (
        <td
          style={{
            display: "inline-flex",
            alignItems: "center",
            width: "100%",
          }}
          className="actionGridEnd"
        >
          <Container
            signatureTypeId={signatureTypeId}
            killMe={killMe}
            id={this.props.dataItem.id}
            view={view}
            setIsShowAutorizationModal={setIsShowAutorizationModal}
            userTypeId={true}
            urlToSend={urlToSend}
          >
            <React.Fragment>
              <div
                style={{ display: "inline-block", margin: "auto" }}
                className={`grid-btn-action ${visibilityIcon ? "visibilityIconHide" : ""}`}
              >
                <Tooltip
                  openDelay={600}
                  position="top"
                  anchorElement="target"
                  tooltipClassName="tooltipGeneralStyle"
                >
                  <span
                    title={tooltipDetail}
                    onClick={() => {
                      edit(this.props.dataItem);
                    }}
                  >
                    {" "}
                    {seeDetail}{" "}
                  </span>
                </Tooltip>
              </div>
              {visibilityIcon && (
                <div className="visibilityIcon" style={{ margin: "auto" }}>
                  <SvgIcon>
                    <path d="M0 0h24v24H0V0z" fill="none" />
                    <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" />
                  </SvgIcon>
                </div>
              )}
            </React.Fragment>
          </Container>
          {isAReportDetail !== true && Number(this.props.dataItem.user.userTypeId) !== Number(process.env.REACT_APP_USER_TYPE_INVITADO) ? (
            <div className="icon-tracking">
              <Link
                to={{
                  pathname: `/document-tracking/${this.props.dataItem.id}`,
                  params: { dataItem: this.props.dataItem },
                }}
              >
                <img
                  src="https://a3cloud-development.s3.us-west-2.amazonaws.com/microservices/MiFirma/assets/images/icon_tracking_document.png"
                  width={20}
                  alt="tracking-icon"
                ></img>
              </Link>
            </div>
          ) : null}
          {hideTrash || isHideTrash ? null : (
            <div style={{ display: "inline-block" }}>
              <Tooltip
                openDelay={600}
                position="top"
                anchorElement="target"
                tooltipClassName="tooltipGeneralStyle"
              >
                <span
                  className="button-sign-request-delete"
                  onClick={() => {
                    toggleDialogDeleteRequest(this.props.dataItem);
                  }}
                >
                  <i
                    title={tooltipDelete}
                    className="k-icon k-i-delete k-i-trash"
                  ></i>
                </span>
              </Tooltip>
            </div>
          )}
        </td>
      );
    }
  };
}
